import React, { createContext, useState } from 'react';
import Toursnavbar from '../components/Toursnavbar';
import Footer from '../components/Footer';
import Progressbars from '../components/progressbar';
import BackgroundTour from '../components/backgroundTour';
import FilterSection from '../components/FilterSection';
 
// Create the Context
export const CountryName = createContext();
 
function TourSearchPage() {
  // Create state for the country name
  const [country, setCountry] = useState("");
 
  return (
    <div>
      {/* Use the Provider to pass the country and setter function */}
      <CountryName.Provider value={{ country, setCountry }}>
        <Toursnavbar />
        <BackgroundTour />
        <Progressbars />
        {/* <Footer /> */}
      </CountryName.Provider>
      <Footer />
    </div>
  );
}
 
export default TourSearchPage;
 